import React from 'react';
import { DialogTitle } from '@mui/material';
import ModalCloseButton from './ModalCloseButton';
import { MODAL_STYLES } from '../../utils/modalStyles';

/**
 * Standardized modal header with title and close button
 * Combines DialogTitle and ModalCloseButton with consistent positioning
 *
 * @param {string} title - Modal title
 * @param {function} onClose - Function to call when close button is clicked
 * @param {boolean} showCloseButton - Whether to show close button (default: true)
 * @param {object} titleSx - Additional styling for DialogTitle (optional)
 */
export default function ModalHeader({
  title,
  onClose,
  showCloseButton = true,
  titleSx = {}
}) {
  const combinedTitleSx = {
    ...MODAL_STYLES.dialogTitle,
    ...titleSx,
  };

  return (
    <>
      <DialogTitle sx={combinedTitleSx}>
        {title}
      </DialogTitle>
      {showCloseButton && onClose && (
        <ModalCloseButton onClick={onClose} />
      )}
    </>
  );
}